export class VideoPlayerEventsNormalizer {
  constructor(callback: (event: VideoPlayerEvent) => void) {
    this.callback = callback;
  }

  private readonly callback: (event: VideoPlayerEvent) => void;

  handleReactPlayerPlay(): void {
    // console.log("[N] PLAY");
    if (!this.playing) {
      this.playing = true;
      this.callback({
        type: "Play",
      });
    }
  }

  handleReactPlayerProgress(state: {
    played: number;
    playedSeconds: number;
    loaded: number;
    loadedSeconds: number;
  }): void {
    // console.log("[N] PROGRESS", state.playedSeconds);
    if (this.playing) {
      const timeSinceLastSeek = new Date().getTime() - this.lastSeekTime;
      const SEEK_EPSILON = 3000;
      if (timeSinceLastSeek > SEEK_EPSILON && state.playedSeconds > this.currentSeconds) {
        this.currentSeconds = state.playedSeconds;
        this.callback({
          type: "Progress",
          seconds: state.playedSeconds,
        });
      }
    }
  }

  handleReactPlayerPause(): void {
    // console.log("[N] PAUSE");
    if (this.playing) {
      this.playing = false;
      this.callback({
        type: "Pause",
      });
    } else {
      // This deals with some weird behaviour when playing YouTube
      // videos. We get a Pause event after an Ended event, and it's the
      // only way to know that we have rewinded.
      this.currentSeconds = 0;
      this.lastSeekTime = new Date().getTime();
      this.callback({
        type: "Seek",
        seconds: 0,
      });
    }
  }

  handleReactPlayerSeek(_seconds: number): void {
    // console.log("[N] SEEK", seconds);
  }

  handleReactPlayerEnded(): void {
    // console.log("[N] ENDED");
    if (this.playing) {
      this.playing = false;
      this.callback({
        type: "Pause",
      });
    }
    this.currentSeconds = 0;
    this.lastSeekTime = new Date().getTime();
    this.callback({
      type: "Seek",
      seconds: 0,
    });
  }

  handleSeekTo(seconds: number): void {
    // console.log("[N] SeekTo", seconds);
    this.currentSeconds = seconds;
    this.lastSeekTime = new Date().getTime();
    this.callback({
      type: "Seek",
      seconds: seconds,
    });
  }

  private playing: boolean = false;
  private currentSeconds: number = 0;
  private lastSeekTime: number = 0;
}

// BOTH
// PROGRESS at first load    <-- same
// single progress followed after "pause"

// URL

// Youtube

export type VideoPlayerEvent =
  | VideoPlayerEvent.Play
  | VideoPlayerEvent.Pause
  | VideoPlayerEvent.Seek
  | VideoPlayerEvent.Progress;

export declare namespace VideoPlayerEvent {
  export interface Play {
    type: "Play";
  }

  export interface Pause {
    type: "Pause";
  }

  export interface Seek {
    type: "Seek";
    seconds: number;
  }

  export interface Progress {
    type: "Progress";
    seconds: number;
  }
}
